module.exports = __webpack_public_path__ + "static/img/creator_country_invite_text2.cd149ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/creator/creator_country_invite_text2.png
// module id = 8b00
// module chunks = 0